import type { Role } from '@domain/entities';
import type { IRoleRepository } from '@domain/repositories';
import type {
  PaginatedResult,
  RoleFilters,
  RolePayload,
  RoleUpdatePayload,
} from '@application/dto';
import type { IHttpClient } from '@application/ports';
import { API_ENDPOINTS } from '@infrastructure/config';

export class RoleRepository implements IRoleRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  async list(filters: RoleFilters): Promise<PaginatedResult<Role>> {
    const response = await this.httpClient.get<PaginatedResult<Role>>(
      API_ENDPOINTS.roles.base,
      {
        params: {
          page: filters.page,
          limit: filters.limit,
          ...(filters.search ? { search: filters.search } : {}),
          ...(filters.applicationId ? { applicationId: filters.applicationId } : {}),
          ...(filters.onlyGlobal ? { onlyGlobal: true } : {}),
          ...(filters.onlyActive ? { onlyActive: true } : {}),
        },
      }
    );

    return response.data;
  }

  async create(payload: RolePayload): Promise<Role> {
    const response = await this.httpClient.post<Role>(API_ENDPOINTS.roles.base, payload);
    return response.data;
  }

  async update(id: string, payload: RoleUpdatePayload): Promise<Role> {
    const response = await this.httpClient.patch<Role>(API_ENDPOINTS.roles.byId(id), payload);
    return response.data;
  }

  async activate(id: string): Promise<Role> {
    const response = await this.httpClient.patch<Role>(API_ENDPOINTS.roles.activate(id));
    return response.data;
  }

  async deactivate(id: string): Promise<Role> {
    const response = await this.httpClient.patch<Role>(API_ENDPOINTS.roles.deactivate(id));
    return response.data;
  }
}
